import React from 'react';
import CustomCheckbox from 'components/CustomCheckbox/CustomCheckbox';
import styles from 'assets/jss/material-dashboard-pro-react/components/simpleTableStyle';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';

// @ts-ignore
const useStyles = makeStyles(styles);

export interface IColumn {
	header: React.ReactElement | string;
	accessor?: string | number;
	cell: (row: any) => void;
	width?: number;
	widthPercentage?: boolean;
}

interface IRowProps {
	row: any;
	idAccessor: string;
	columns: IColumn[];
	selectedItems: Array<string | number>;
	setSelectedItems: (item: any) => void;
	withCheckboxes: boolean;
}
const Row = ({ row, idAccessor, columns, selectedItems, setSelectedItems, withCheckboxes }: IRowProps) => {
	const classes = useStyles();
	return (
		<div
			className={classNames({
				// @ts-ignore
				[classes.rowSelected]: selectedItems.indexOf(row?.[idAccessor ? idAccessor : '']) >= 0,
				[classes.rowDisabled]: row?.disabled,
			})}
		>
			{withCheckboxes && (
				<div className={classes.checkboxWrapper}>
					<CustomCheckbox
						disableLabel
						// @ts-ignore
						checked={selectedItems.indexOf(row?.[idAccessor]) >= 0}
						disabled={row?.disabled}
						onClick={() => {
							// @ts-ignore
							const index = selectedItems.indexOf(row?.[idAccessor]);
							if (index >= 0) {
								setSelectedItems((items: any) => {
									const _items = [...items];
									_items.splice(index, 1);
									return _items;
								});
							} else {
								setSelectedItems((items: any) => [...items, row?.[idAccessor]]);
							}
						}}
					/>
				</div>
			)}
			{columns.map((column, index) => (
				<div
					key={index}
					style={
						column.widthPercentage
							? { width: `${column.width}%` }
							: { minWidth: `${column.width}px`, maxWidth: `${column.width}px` }
					}
				>
					{column.cell ? column.cell(row) : row?.[column.accessor!]}
				</div>
			))}
		</div>
	);
};

export default Row;
